import React , {Component} from 'react';

export class Path extends Component{
  render(){
    const {d, fill, fillRule, clipRule} = this.props;

    const pathProps = {
      d,
      fill,
      fillRule,
      clipRule
    };

    return(
      <path {...pathProps}/>
    )
  }
}